import * as React from "react";
import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";

export function ExistingDriversPicker({ existingDrivers, selected, onPick }) {
  const [q, setQ] = React.useState("");

  const selectedIds = new Set((selected ?? []).map((d) => d.driverId));
  const filtered = (existingDrivers ?? [])
    .filter((d) => !d.driverId || !selectedIds.has(d.driverId))
    .filter((d) => {
      const hay = `${d.firstName} ${d.lastName} ${d.licenseNumber} ${d.licenseState}`.toLowerCase();
      return hay.includes(q.toLowerCase());
    });

  return (
    <div className="space-y-3">
      <Input
        placeholder="Search by name / license / state..."
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      {filtered.length === 0 ? (
        <div className="rounded-md border p-4 text-sm text-gray-600">No existing drivers to show.</div>
      ) : (
        <div className="max-h-96 overflow-auto rounded-md border divide-y">
          {filtered.map((d) => (
            <div key={d.id} className="p-3 flex items-center justify-between text-sm">
              <div>
                <div className="font-medium">
                  {d.firstName} {d.lastName}
                  {d.status === "inactive" && (
                    <span className="ml-2 text-xs rounded bg-gray-100 text-gray-700 px-2 py-0.5">Inactive</span>
                  )}
                </div>
                <div className="text-xs text-gray-500">
                  Lic #{d.licenseNumber} — {d.licenseState}
                </div>
              </div>
              <Button size="sm" onClick={() => onPick(d)}>Add</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}